import { gql } from '@apollo/client';

const userEventParticipationInfoCalendarViewFragment = gql`
  fragment UserEventParticipationInfoFields on TargetUserEventParticipationInfo {
    ExternalUserId
    EventId
    IsPotentialAtm
    IsEventAtm
    IsEventParticipant
    IsUserInvitedAtm
    IsUserAtlObserver
    IsUserInvitedAtlObserver
  }
`;

export default userEventParticipationInfoCalendarViewFragment;
